import { Component, EventEmitter, Input, Output} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { OnBaseMappedKeyword } from "../../../../common/models/onBaseIntegrationAndMapping.model";


@Component({
    selector: 'onbase-mapped-keyword-input',
    templateUrl: './onbase-mapped-keyword-input.component.html',
    styleUrls: ['./onbase-mapped-keyword-input.component.scss'],
    standalone: false
})

export class OnBaseMappedKeywordInputComponent {

    @Input() mappedKeyWord: OnBaseMappedKeyword = {} as unknown as OnBaseMappedKeyword;
    @Input() entity: any = null;
    @Input() parentFormGroup?: FormGroup;
    @Input() isDisabled: boolean = false;

    @Output() keywordValueUpdated: EventEmitter<OnBaseMappedKeyword> = new EventEmitter<OnBaseMappedKeyword>();

    constructor() {
    }

    onBlur() {
        this.keywordValueUpdated.emit(this.mappedKeyWord);
	}

	dateCtrlUpdated(ctrlInfo: any): void {
		if (this.parentFormGroup != null) {
			let ctrl = this.parentFormGroup.get(this.mappedKeyWord.name);
			if (ctrl != null) {
                if (ctrlInfo.date instanceof Date) {
                    let value = ctrlInfo.date.toLocaleDateString();
                    ctrl.setValue(value);
                } else {
                    ctrl.setValue(null);
                }
				
			}
		}
		this.keywordValueUpdated.emit(this.mappedKeyWord);
	}
}